import { ZendeskKnowledge } from "api-client";

export enum ACTIONS {
    GET_ZENDESK_KNOWLEDGE_REQUEST = "KNOWLEDGE/GET_ZENDESK_KNOWLEDGE_REQUEST",
    GET_ZENDESK_KNOWLEDGE_SUCCESS = "KNOWLEDGE/GET_ZENDESK_KNOWLEDGE_SUCCESS",
    GET_ZENDESK_KNOWLEDGE_FAILURE = "KNOWLEDGE/GET_ZENDESK_KNOWLEDGE_FAILURE",
}

interface GetZendeskKnowledgeRequest {
    type: ACTIONS.GET_ZENDESK_KNOWLEDGE_REQUEST;
}

interface GetZendeskKnowledgeSuccess {
    type: ACTIONS.GET_ZENDESK_KNOWLEDGE_SUCCESS;
    payload: ZendeskKnowledge;
}

interface GetZendeskKnowledgeFailure {
    type: ACTIONS.GET_ZENDESK_KNOWLEDGE_FAILURE;
}

export type ActionType =
    | GetZendeskKnowledgeRequest
    | GetZendeskKnowledgeSuccess
    | GetZendeskKnowledgeFailure;
